import type { MalleableUiProductFlags } from '@atlassian/editor-plugin-malleable-ui/malleableUiPluginType';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const createMalleableUiProductFlags = (
	flags: FlagsStateContainer | undefined,
): MalleableUiProductFlags | undefined => {
	if (!flags) {
		return undefined;
	}

	return {
		showFlag: ({ autoDismissSeconds, description, icon, id, onDismissed, title, type }) => {
			void flags.showFlag({
				customIcon: icon,
				description,
				id,
				onClose: onDismissed,
				title,
				type,
				...(autoDismissSeconds !== undefined
					? {
							autoDismissSeconds,
							close: 'auto' as const,
						}
					: {}),
			});
		},
		hideFlag: (id) => {
			void flags.hideFlag(id);
		},
	};
};
